var _defs, _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaylistdaplus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 992.53 293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke: #ffa700;\r\n        stroke-linecap: round;\r\n        stroke-width: 11px;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: url(#Gradiente_sem_nome_33);\r\n        stroke-width: 5px;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#Gradiente_sem_nome_19);\r\n        stroke-width: 0px;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_19",
    "data-name": "Gradiente sem nome 19",
    x1: 28.39,
    y1: 145.19,
    x2: 723.89,
    y2: 145.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#481cc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#4b1ec4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#5424bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#652fb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#7c3fa4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#9a5391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#aa5e88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#b1637b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c97455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#dc8236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#eb8d1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#f6940d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#fc9903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ff9b00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_33",
    "data-name": "Gradiente sem nome 33",
    x1: 0,
    y1: 146.5,
    x2: 992.53,
    y2: 146.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#481cc6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#491ec5",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#4e25c4",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#5731c2",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#6242bf",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#7157bb",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#8371b7",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#8674b7"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m116.8,76.08c0,6.89-7.64,12.53-17.04,12.53h-34.95v23.43c0,2.63-2.13,4.76-4.63,4.76h-26.93c-2.63,0-4.76-2.13-4.76-4.76V46.27c0-2.51,2.13-4.63,4.76-4.63h66.52c9.4,0,17.04,5.64,17.04,12.53v21.92Zm-36.08-19.79c0-2.13-3.13-3.76-6.89-3.76h-9.02v26.56h9.02c3.76,0,6.89-1.63,6.89-3.63v-19.17Zm119.01,55.75c0,2.63-2.13,4.76-4.64,4.76h-64.52c-2.63,0-4.76-2.13-4.76-4.76V46.27c0-2.51,2.13-4.63,4.76-4.63h26.93c2.51,0,4.63,2.13,4.63,4.63v54.87h32.95c2.51,0,4.64,2.13,4.64,4.64v6.26Zm103.98,4.76h-30.82c-2.63,0-5.51-2.13-6.01-4.64l-2.25-10.4h-18.54l-2.38,10.4c-.5,2.51-3.38,4.64-5.89,4.64h-30.94c-2.13,0-3.38-1.75-3.38-3.88,0-.63.13-1.25.38-1.88l21.3-64.77c.75-2.38,3.38-4.63,6.01-4.63h48.36c2.63,0,5.14,2.25,5.89,4.63l21.42,64.77c.25.75.38,1.5.38,2.25,0,2.13-1.38,3.51-3.51,3.51Zm-41.47-26.18l-7.02-31.82-6.89,31.82h13.91Zm139.68,13.66c0,6.89-7.64,12.53-17.04,12.53h-54.24c-9.4,0-17.04-5.64-17.04-12.53v-4.64c0-2.63,2.13-4.76,4.76-4.76h26.93c2.51,0,4.63,2.13,4.63,4.76v2c0,4.89,3.51,8.89,7.89,8.89s7.77-4.01,7.77-8.89v-13.53h-34.95c-9.4,0-17.04-5.64-17.04-12.53v-29.19c0-2.63,2.13-4.76,4.76-4.76h26.93c2.51,0,4.63,2.13,4.63,4.76v25.05c0,4.89,3.51,8.77,7.89,8.77s7.77-3.88,7.77-8.77v-25.05c0-2.63,2.13-4.76,4.76-4.76h26.93c2.51,0,4.64,2.13,4.64,4.76v57.88Zm82.93,7.77c0,2.63-2.13,4.76-4.64,4.76h-64.52c-2.63,0-4.76-2.13-4.76-4.76V46.27c0-2.51,2.13-4.63,4.76-4.63h26.93c2.51,0,4.63,2.13,4.63,4.63v54.87h32.95c2.51,0,4.64,2.13,4.64,4.64v6.26Zm42.72,0c0,2.63-2.13,4.76-4.64,4.76h-26.93c-2.63,0-4.76-2.13-4.76-4.76V46.27c0-2.51,2.13-4.63,4.76-4.63h26.93c2.51,0,4.64,2.13,4.64,4.63v65.77Zm100.35-7.77c0,8.27-9.4,12.53-16.54,12.53h-58.38c-7.14,0-16.41-4.26-16.41-12.53v-9.4c0-2.51,2-4.64,4.51-4.64h29.06c4.01,0,4.51,3.51,4.51,6.76,0,4.51,3.01,8.77,7.52,8.77s7.64-4.26,7.64-8.77c0-3.13-.5-5.64-2.63-8.14-1.63-1.88-4.01-4.01-6.51-4.38l-23.68-3.38c-10.52-1.5-20.42-6.14-20.42-18.54v-8.39c0-8.27,9.27-12.53,16.41-12.53h58.38c7.14,0,16.54,4.26,16.54,12.53v9.4c0,2.51-2,4.64-4.63,4.64h-28.94c-4.01,0-4.51-3.51-4.51-6.77,0-4.51-3.01-8.89-7.64-8.89s-7.52,4.38-7.52,8.89c0,6.64,2.25,11.53,9.02,12.53l23.8,3.38c11.4,1.63,20.42,4.89,20.42,18.54v8.39Zm95.96-51.74c0,2.63-2.13,4.76-4.63,4.76h-21.17v54.75c0,2.63-2.13,4.76-4.76,4.76h-27.69c-2.63,0-4.64-2.13-4.64-4.76v-54.75h-21.92c-2.63,0-4.76-2.13-4.76-4.76v-6.26c0-2.51,2.13-4.63,4.76-4.63h80.18c2.51,0,4.63,2.13,4.63,4.63v6.26ZM130.35,234.28c0,7.96-8.82,14.46-19.67,14.46H33.89c-3.04,0-5.5-2.46-5.5-5.5v-75.93c0-2.89,2.46-5.35,5.5-5.35h76.79c10.85,0,19.67,6.51,19.67,14.46v57.85Zm-41.94-49.46c0-5.64-5.06-10.27-11.28-10.27h-6.8v61.46h6.8c6.22,0,11.28-4.48,11.28-10.12v-41.07Zm165.01,63.92h-35.58c-3.04,0-6.36-2.46-6.94-5.35l-2.6-12h-21.4l-2.75,12c-.58,2.89-3.9,5.35-6.8,5.35h-35.72c-2.46,0-3.9-2.03-3.9-4.48,0-.72.14-1.45.43-2.17l24.59-74.77c.87-2.75,3.9-5.35,6.94-5.35h55.82c3.04,0,5.93,2.6,6.8,5.35l24.73,74.77c.29.87.43,1.74.43,2.6,0,2.46-1.59,4.05-4.05,4.05Zm-47.87-30.23l-8.1-36.73-7.95,36.73h16.05Zm197.41-16.78c0,7.95-8.82,14.46-19.67,14.46h-40.35v27.04c0,3.04-2.46,5.5-5.35,5.5h-31.09c-3.04,0-5.5-2.46-5.5-5.5v-75.93c0-2.89,2.46-5.35,5.5-5.35h76.79c10.85,0,19.67,6.51,19.67,14.46v25.31Zm-41.65-22.85c0-2.46-3.62-4.34-7.95-4.34h-10.41v30.66h10.41c4.34,0,7.95-1.88,7.95-4.19v-22.13Zm137.39,64.36c0,3.04-2.46,5.5-5.35,5.5h-74.48c-3.04,0-5.5-2.46-5.5-5.5v-75.93c0-2.89,2.46-5.35,5.5-5.35h31.09c2.89,0,5.35,2.46,5.35,5.35v63.34h38.04c2.89,0,5.35,2.46,5.35,5.35v7.23Zm109.33-8.97c0,7.96-8.82,14.46-19.67,14.46h-62.62c-10.85,0-19.67-6.51-19.67-14.46v-66.96c0-2.89,2.46-5.35,5.5-5.35h31.09c2.89,0,5.35,2.46,5.35,5.35v58.57c0,5.64,4.05,10.12,9.11,10.12s8.97-4.48,8.97-10.12v-58.57c0-2.89,2.46-5.35,5.5-5.35h31.09c2.89,0,5.35,2.46,5.35,5.35v66.96Zm115.84,0c0,9.55-10.85,14.46-19.09,14.46h-67.39c-8.24,0-18.95-4.92-18.95-14.46v-10.85c0-2.89,2.31-5.35,5.21-5.35h33.55c4.63,0,5.21,4.05,5.21,7.81,0,5.21,3.47,10.12,8.68,10.12s8.82-4.92,8.82-10.12c0-3.62-.58-6.51-3.04-9.4-1.88-2.17-4.63-4.63-7.52-5.06l-27.33-3.9c-12.15-1.74-23.57-7.09-23.57-21.4v-9.69c0-9.54,10.7-14.46,18.95-14.46h67.39c8.24,0,19.09,4.92,19.09,14.46v10.85c0,2.89-2.31,5.35-5.35,5.35h-33.41c-4.63,0-5.21-4.05-5.21-7.81,0-5.21-3.47-10.27-8.82-10.27s-8.68,5.06-8.68,10.27c0,7.67,2.6,13.31,10.41,14.46l27.48,3.9c13.16,1.88,23.57,5.64,23.57,21.4v9.69Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.5,
    y: 2.5,
    width: 987.53,
    height: 288,
    rx: 32.47,
    ry: 32.47
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m792.09,90.91v-10.33c0-5.43,5.88-8.82,10.58-6.11l57.08,32.96,57.08,32.96c4.7,2.71,4.7,9.5,0,12.22l-57.08,32.96-57.08,32.96c-4.7,2.71-10.58-.68-10.58-6.11v-86.56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistdaplus);
export default __webpack_public_path__ + "static/media/playlistdaplus.bd1575c37a66ff3e86a066edd483b490.svg";
export { ForwardRef as ReactComponent };